import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import CircularProgress from '@mui/material/CircularProgress';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { DownArrow } from '@common/utils/icons/icons';

const DeleteAccordionList: React.FC<{
  title: React.ReactNode | string;
  items: { id: string; name: string }[];
  loadingText: string;
  isLoading: boolean;
}> = ({ title, items, loadingText, isLoading }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<DownArrow />}>
        {isLoading ? (
          <React.Fragment>
            <CircularProgress size={24} sx={{ mr: 2 }} />
            {loadingText}
          </React.Fragment>
        ) : (
          title
        )}
      </AccordionSummary>
      {items.length > 0 && (
        <AccordionDetails>
          <List>
            {items.map((i) => (
              <ListItem key={i.id}>{i.name}</ListItem>
            ))}
          </List>
        </AccordionDetails>
      )}
    </Accordion>
  );
};

export default DeleteAccordionList;
